import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withCreateUpload } from './mutations/createUpload';

class UploaderFile extends Component {
  cancelMutations = false;

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      file,
      mutate,
      onError,
      onUploading
    } = this.props;

    onUploading && onUploading();

    mutate({
      variables: {
        input: {
          filename: file.name
        }
      }
    }).then(({ data }) => {
      if (this.cancelMutations) { return; }

      this.setState({ upload: data.createUpload });
      this.directUpload(data.createUpload);
    }).catch((error) => {
      onError && onError(error);
    });
  }

  componentWillUnmount() {
    this.cancelMutations = true;
  }

  render() {
    return (
      <div>{this.state.upload ? '' : 'Uploading...'}</div>
    );
  }

  directUpload(upload) {
    const { onError, onUploaded, file } = this.props;

    fetch(upload.presignedUrl, {
      method: 'PUT',

      headers: {
        'Content-Type': 'application/octet-stream'
      },
      body: file
    }).then((success) => {
      if (this.cancelMutations) { return; }

      const state = {
        id: this.state.upload.id,
        url: success.url,
        file: file
      };

      onUploaded && onUploaded(state, file);
    }).catch((error) => {
      onError && onError(error);
    });
  }
}

UploaderFile.defaultProps = {};

UploaderFile.propTypes = {
  file: PropTypes.object.isRequired,
  mutate: PropTypes.func.isRequired,
  onUploading: PropTypes.func,
  onUploaded: PropTypes.func,
  onError: PropTypes.func
};

export default withCreateUpload()(UploaderFile);
